/**
 * App constants
 */
export class AppConst {
  // NOTE: If you change this value, also update the <title> and meta <description> in public/index.html.
  public static readonly APP_NAME = "DashGifts";
  public static readonly HTTP_API_V1_ENDPOINT = "apiV1";
  public static readonly CALLABLE_API_V1_ENDPOINT = "callableApiV1";
  public static readonly WOO_AUTH_API_ENDPOINT = "/wc-auth/v1/authorize";

  // Branding — to rebrand, change APP_NAME only.
  // NOTE: public/index.html (meta description, <title>) and
  //       public/manifest.json ("short_name", "name") also contain the app name
  //       and must be updated manually — they cannot import TS constants.
  public static readonly APP_LOGO_URL = "/logo512.png";
}

/**
 * App Routes
 */
export class AppRoute {
  public static readonly SIGNIN = "/signin";
  public static readonly SIGNED_IN = "/signed-in";
  public static readonly DASHBOARD = "/dashboard";
  public static readonly VERIFY_EMAIL = "/verify-email";
  public static readonly CONNECT_WOO_STORE = "/connect-woo-store";
  public static readonly CONNECT_WOO_STORE_MSG = "/connect-woo-store-msg";
  public static readonly PRIVACY_POLICY = "/privacy-policy";
  public static readonly TERMS = "/terms-and-conditions";
}
